// import { auth, db } from "../../Firebase/firebase";
// Replaced with backend API calls
import { useNavigate } from "react-router-dom";
import API_URL from '../../../utils/api';

export default function useAuthentication() {
  const navigate = useNavigate();
  const validateEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  const validatePassword = (password) => password.length >= 6;
  const handleSubmit = async ({
    e,
    email,
    password,
    name,
    isLogin,
    age,
    gender,
    customGender,
    interests,
    setError,
    setSuccess,
    setLoading,
    setIsLogin
  }) => {
    e.preventDefault();
    setError("");
    setSuccess("");
    if (!email || !password || (!isLogin && !name)) {
      setError("Please fill in all fields.");
      return;
    }
    if (!validateEmail(email)) {
      setError("Please enter a valid email address.");
      return;
    }
    if (!validatePassword(password)) {
      setError("Password must be at least 6 characters.");
      return;
    }
    setLoading(true);
    try {
      if (isLogin) {
        // Login with backend
        const response = await fetch(`${API_URL}/api/auth/login`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email, password })
        });
        const result = await response.json();
        if (!response.ok) {
          setError(result.message || "Login failed.");
          setLoading(false);
          return;
        }
        setSuccess("Welcome back!");
  localStorage.setItem("isLoggedIn", "true");
  sessionStorage.setItem("userId", result.user.id);
        // Check profile completeness using backend
        try {
          const checkResponse = await fetch(`${API_URL}/api/profile/is-complete/${result.user.id}`);
          const checkResult = await checkResponse.json();
          if (checkResult.isComplete) {
            setTimeout(() => navigate("/dashboard"), 1000);
          } else {
            setTimeout(() => navigate("/complete-profile"), 1000);
          }
        } catch {
          setTimeout(() => navigate("/dashboard"), 1000);
        }
      } else {
        // Signup with backend
        const response = await fetch(`${API_URL}/api/auth/signup`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            name,
            email,
            password,
            age,
            gender: gender === "Other" ? customGender : gender,
            interests,
            avatar: "https://ui-avatars.com/api/?name=" + encodeURIComponent(name)
          })
        });
        const result = await response.json();
        if (!response.ok) {
          setError(result.message || "Signup failed.");
          setLoading(false);
          return;
        }
        setSuccess("Signup successful! Please check your email to verify your account.");
        setTimeout(() => setIsLogin(true), 2000);
      }
    } catch (err) {
      setError("Something went wrong. Please check your credentials and try again.");
    }
    setLoading(false);
  };
  // Google sign-in migration: If backend supports OAuth, implement here
  const handleGoogleSignIn = async ({
    setError,
    setSuccess,
    setLoading,
    navigate,
    credential
  }) => {
    setError("");
    setSuccess("");
    setLoading(true);
    try {
      // Send Google credential token to backend
      const response = await fetch(`${API_URL}/api/google-signin`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ token: credential })
      });
      const result = await response.json();
      if (!response.ok) {
        setError(result.message || "Google sign-in failed.");
        setLoading(false);
        return;
      }
      if (!result.user || !result.user.age || !result.user.gender || !result.user.interests) {
        localStorage.setItem("isLoggedIn", "true");
        sessionStorage.setItem("userId", result.user.id);
        navigate("/complete-profile");
        setSuccess("Signed in with Google! Please complete your profile.");
      } else {
        localStorage.setItem("isLoggedIn", "true");
        sessionStorage.setItem("userId", result.user.id);
        navigate("/dashboard");
        setSuccess("Signed in with Google!");
      }
    } catch (err) {
      setError("Something went wrong. Please check your credentials and try again.");
    }
    setLoading(false);
  };
  const handlePasswordReset = async ({
    e,
    resetEmail,
    setError,
    setSuccess,
    setLoading,
    setShowReset
  }) => {
    e.preventDefault();
    setError("");
    setSuccess("");
    if (!validateEmail(resetEmail)) {
      setError("Please enter a valid email address.");
      return;
    }
    setLoading(true);
    try {
      // Call backend password reset endpoint
      const response = await fetch(`${API_URL}/api/auth/reset-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: resetEmail })
      });
      const result = await response.json();
      if (!response.ok) {
        setError(result.message || "Password reset failed.");
        setLoading(false);
        return;
      }
      setSuccess("Password reset email sent! Check your inbox.");
      setShowReset(false);
    } catch (err) {
      setError("Something went wrong. Please check your credentials and try again.");
    }
    setLoading(false);
  };
  return {
    handleSubmit,
    handleGoogleSignIn,
    handlePasswordReset
  };
}
